import { useQuery } from '@tanstack/react-query';
import { defaultFolderApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useDocumentTemplates() {
  return useQuery({
    queryKey: queryKeys.documentTemplates.list(),
    queryFn: ({ signal }) =>
      defaultFolderApiClient.getTemplates(toCancelToken(signal)),
    staleTime: 5 * 60_000,
    meta: { errorContext: 'document templates' },
  });
}
